import css from "./LatestActivity.module.css";

import { getActivityText, LatestActivityQueryWithObject } from "~/util/page";
import { formatDate } from "../site/Date";
import { UserLink } from "../site/UserLink";
import { ReactNode } from "react";
import { QuestLink } from "../quest/QuestLink";
import { useRealm, useT } from "~/util/Lang";
import { ItemLink } from "../item/ItemLink";
import { NpcLink } from "../npc/NpcLink";
import { SkillLink } from "../skill/SkillLink";
import { PageLink } from "../page/PageLink";
import { WikiLink } from "../page/WikiLink";

export function LatestActivity(props: {
  data: LatestActivityQueryWithObject[];
}) {
  const { data } = props;
  return (
    <div className={css.root}>
      {data.map((activity, i) => (
        <ItemActivity key={i} activity={activity} />
      ))}
    </div>
  );
}

function ItemActivity(props: { activity: LatestActivityQueryWithObject }) {
  const activity = props.activity;
  const realm = useRealm();

  let link: ReactNode = null;

  switch (activity._) {
    case "quest":
      link = <QuestLink quest={activity.linkData} />;
      break;
    case "npc":
      link = (
        <NpcLink npc={activity.linkData} showIcon={true} showLvl={false} />
      );
      break;
    case "item":
      link = <ItemLink item={activity.linkData} />;
      break;
    case "skill":
      link = <SkillLink data={activity.linkData} />;
      break;
    case "user":
      link = <PageLink page={activity.linkData} />;
      break;
    case "wiki":
      link = <WikiLink page={activity.linkData} />;
      break;
  }

  return (
    <div>
      <div className={css.date}>{formatDate(activity.created_at)}:</div>
      <div className={css.activity}>
        {activity.user && <UserLink user={activity.user} />}{" "}
        {getActivityText(activity.type, activity.action, realm.lang)} {link}
      </div>
    </div>
  );
}
